import React, { Component, Suspense, useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import { ThemeProvider } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";
import Loader from "App/components/Loader";
import AuthWrapper from "hoc/AuthWrapper";
import publicRoutes from "App/publicRoutes";
import { API, ENDPOINTS } from "api/apiService";
import { API_TOKEN,DEVICE_TOKEN } from "../storage/StorageKeys";
import preloadImages from "App/assets/preloadImages";
import "react-toastify/dist/ReactToastify.css";
import "./theme/index.scss";
import theme from "./theme/appTheme";
import { setupToken } from "../firebase";
import { handlePermission } from "../APN";
import StorageManager from "../storage/StorageManager";


import { useLocation } from "react-router-dom";

const Layout = Loadable({
  loader: () => import("./layout"),
  loading: Loader,
});

const Router = (props) => {
  const authPages = publicRoutes.map((route, index) => {
    return route.component ? (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        component={route.component}
      />
    ) : null;
  });

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />
        {authPages}
        <AuthWrapper path="/" component={Layout} />
      </Switch>
    </Suspense>
  );
};

const App = (props) => {
  const search = useLocation().search;
  useEffect(() => {
    preloadImages();
    // Create the script tag, set the appropriate attributes
    var script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&callback=initMap`;
    script.defer = true;
    // Attach your callback function to the `window` object
    window.initMap = function () {
      // JS API is loaded and available
    };
    // Append the 'script' element to 'head'
    document.head.appendChild(script);
  }, []);

  

  useEffect(()=>{
    if (window.safari && StorageManager.get(API_TOKEN)) {
      let data = window.safari.pushNotification.permission("web.com.staffing.goagalia")
        if (data.permission === "granted") {
          handlePermission(updateNotificationToken)
        }
    }
    else if(StorageManager.get(API_TOKEN)){
      updateNotificationToken()
    }
  },[])

  
  const updateNotificationToken = async (token) => {
    console.log("update notification")
    let packet;
    if (window.safari) {
      packet = {
        device_token: token,
        is_safari: true,
        is_safari_permit: true,
      };
    } else {
      packet = {
        device_token: await setupToken(),
      };
    }
    if(StorageManager.get(DEVICE_TOKEN)!==packet.device_token && packet.device_token){
      StorageManager.put(DEVICE_TOKEN,packet.device_token)

    // API.patch(ENDPOINTS.UPDATE_TOKEN, packet)
    //   .then((response) => {
    //     if (response.statusCode === 200) {
    //       console.log("Notfication Enabled Successfully!");
    //     }
    //   })
    //   .catch((error) => {
    //     if (error.response.status !== 500) {
    //       if ([400, 405, 422, 403].includes(error.response.data.statusCode)) {
    //         console.log(error.response.data.error.message[0]);
    //       }
    //     }
    //   })
     }

  };

  return (
    <ThemeProvider theme={theme} >
      <Router />
      <ToastContainer />
    </ThemeProvider>
  );
};


export default App;
